import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-note-action-form',
  templateUrl: './operation-note-action-form.component.html',
  styleUrls: ['./operation-note-action-form.component.scss']
})
export class OperationNoteActionFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
